import { Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, LogOut, Store } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const AdminShell = ({ children, active }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const nav = [
    { key: "overview", label: "Overview", icon: LayoutDashboard, to: "/admin" },
    { key: "products", label: "Products", icon: Package, to: "/admin" },
    { key: "orders", label: "Orders", icon: ShoppingCart, to: "/admin" },
  ];

  return (
    <div className="flex min-h-screen bg-zinc-50">
      <aside className="hidden w-60 shrink-0 flex-col border-r border-zinc-200 bg-white md:flex">
        <div className="border-b border-zinc-200 px-6 py-5">
          <Link to="/admin" className="font-display text-lg tracking-[0.16em]">KK ADMIN</Link>
        </div>
        <nav className="flex-1 px-3 py-4">
          {nav.map((n) => (
            <Link
              key={n.label}
              to={n.to}
              className={`mb-1 flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${
                active === n.key ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-100"
              }`}
              data-testid={`admin-nav-${n.key}`}
            >
              <n.icon size={16} /> {n.label}
            </Link>
          ))}
        </nav>
        <div className="border-t border-zinc-200 p-3">
          <Link to="/" className="mb-1 flex items-center gap-3 px-3 py-2.5 text-sm text-zinc-600 hover:bg-zinc-100">
            <Store size={16} /> View Store
          </Link>
          <button
            onClick={() => { logout(); navigate("/admin/login"); }}
            className="flex w-full items-center gap-3 px-3 py-2.5 text-sm text-zinc-600 hover:bg-zinc-100"
            data-testid="admin-logout"
          >
            <LogOut size={16} /> Logout
          </button>
        </div>
      </aside>

      <div className="flex-1">
        <header className="flex items-center justify-between border-b border-zinc-200 bg-white px-4 py-4 md:px-8">
          <h1 className="font-display text-lg capitalize">{active}</h1>
          <div className="flex items-center gap-3">
            <span className="hidden text-xs text-zinc-500 sm:inline">{user?.email}</span>
            <button onClick={() => { logout(); navigate("/admin/login"); }} className="text-zinc-500 hover:text-zinc-900 md:hidden">
              <LogOut size={18} />
            </button>
          </div>
        </header>
        <div className="p-4 md:p-8">{children}</div>
      </div>
    </div>
  );
};
